import React from 'react';
import PropTypes from 'prop-types';
import FormFieldSpinnerUp from 'wix-ui-icons-common/system/FormFieldSpinnerUp';
import FormFieldSpinnerDown from 'wix-ui-icons-common/system/FormFieldSpinnerDown';
import { st, classes } from './Ticker.st.css';
import InputConsumer from '../InputConsumer';
import { dataHooks } from './constants';

var Ticker = function Ticker(_ref) {
  var onUp = _ref.onUp,
      onDown = _ref.onDown,
      upDisabled = _ref.upDisabled,
      downDisabled = _ref.downDisabled,
      dataHook = _ref.dataHook;
  return /*#__PURE__*/React.createElement(InputConsumer, {
    consumerCompName: Ticker.displayName
  }, function (_ref2) {
    var disabled = _ref2.disabled,
        readOnly = _ref2.readOnly,
        size = _ref2.size,
        border = _ref2.border,
        roundInput = _ref2.roundInput;
    var isUpDisabled = upDisabled || disabled || readOnly;
    var isDownDisabled = downDisabled || disabled || readOnly;
    return /*#__PURE__*/React.createElement("div", {
      className: st(classes.root, {
        size: size,
        border: roundInput ? 'round' : border
      }),
      "data-hook": dataHook
    }, /*#__PURE__*/React.createElement("div", {
      "data-hook": dataHooks.tickerUp,
      "data-disabled": isUpDisabled,
      className: st(classes.up, {
        disabled: isUpDisabled
      }),
      onClick: isUpDisabled ? null : onUp
    }, /*#__PURE__*/React.createElement(FormFieldSpinnerUp, null)), /*#__PURE__*/React.createElement("div", {
      "data-hook": dataHooks.tickerDown,
      "data-disabled": isDownDisabled,
      className: st(classes.down, {
        disabled: isDownDisabled
      }),
      onClick: isDownDisabled ? null : onDown
    }, /*#__PURE__*/React.createElement(FormFieldSpinnerDown, null)));
  });
};

Ticker.displayName = 'Input.Ticker';
Ticker.propTypes = {
  onUp: PropTypes.func,
  onDown: PropTypes.func,
  upDisabled: PropTypes.bool,
  downDisabled: PropTypes.bool,
  dataHook: PropTypes.string
};
export default Ticker;